import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'

import {Amplify} from 'aws-amplify';
import awsconfig from './aws-exports';
import "@aws-amplify/ui-vue/styles.css";

loadFonts()
Amplify.configure(awsconfig);


createApp(App)
  .use(router)
  .use(store)
  .use(vuetify)
  .mount('#app')
